import { Factory, ShieldCheck, Scissors, Truck } from "lucide-react";

const PILLARS = [
  { icon: Factory, title: "Factory Direct Wholesale", desc: "Buy at true wholesale pricing straight from source — built for dealers & distributors." },
  { icon: ShieldCheck, title: "Premium Grade Durability", desc: "Hard-wearing materials engineered for high-traffic commercial and residential use." },
  { icon: Scissors, title: "Custom-Cut Dimensions", desc: "Rolls and tiles supplied to the sizes you need. Dimensions shown exactly as given." },
  { icon: Truck, title: "Fast PAN-India Delivery", desc: "Reliable dispatch and bulk logistics for projects and retail orders alike." },
];

export function WhyTFM() {
  return (
    <section data-testid="why-tfm-section" className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-10 max-w-2xl">
          <span className="font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#10B981]">Why TFM</span>
          <h2 className="mt-2 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            The wholesale partner projects rely on
          </h2>
          <div className="mt-3 h-1 w-12 rounded-full bg-gradient-to-r from-[#10B981] to-[#25D366]" />
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PILLARS.map((p, i) => (
            <div key={p.title}
              className="group rounded-2xl border border-slate-200 bg-slate-50 p-6 transition-all hover:-translate-y-1 hover:border-[#A7F3D0] hover:bg-[#ECFDF5] hover:shadow-lg animate-fade-up"
              style={{ animationDelay: `${i * 70}ms` }}>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0B1B3D] text-[#10B981] transition-colors group-hover:bg-[#10B981] group-hover:text-white">
                <p.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold text-slate-900">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
